// extracted by mini-css-extract-plugin
module.exports = {"slider__wrapper":"W_dQ","slider__element":"W_dR","itemSlider":"W_dS","itemSlider__slideWrapper":"W_dT","itemSlider__pagination":"W_dV","activeSlide":"W_dW"};